export const LOGIN_ROUTE = '/login'
export const ALL_TRAINIGS_PAGE_ROUTE = '/all-trainings'
export const MY_TRAINIGS_PAGE_ROUTE = '/my-trainings'
export const BOOKED_TRAININGS_ROUTE = '/booked-trainings'
export const FINISHED_TRAINIGS_PAGE_ROUTE = '/finished-trainings'
export const REPORTS = '/reports'
